// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Avenir.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Avenir";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
  font-weight: normal;
  font-style: normal;
}
.landing-page {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 43.17%, rgba(255, 255, 255, 0.9) 71.58%, #ffffff 100%);
}

.la-logo {
  position: absolute;
  margin-top: 25px;
  display: flex;
  z-index: 1;
  width: 100%;
  justify-content: center;
}

.la-logo img {
  width: 150px;
  object-fit: contain;
}

.la-background-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1050px;
  object-fit: cover;
  z-index: -1;
}

.landing-page .react-datepicker-wrapper input[type=text] {
  font-size: 14px !important;
}

.landing-page .react-datepicker-wrapper input::placeholder {
  font-size: 15px !important;
}

.la-content {
  position: absolute;
  left: 8%;
  color: #1e1e1e;
  margin-bottom: 80px;
}

@media only screen and (max-width: 381px) {
  .la-content {
    top: 50%;
  }
}
@media screen and (min-width: 382px) and (max-width: 481px) {
  .la-content {
    top: 60%;
  }
}
.la-content h1 {
  font-family: "Avenir", sans-serif;
  margin: 0 0 30px;
  font-size: 64.64px;
  font-weight: 500;
  line-height: 71.82px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.la-content p {
  font-family: "Avenir", sans-serif;
  font-size: 28.73px;
  font-weight: 500;
  line-height: 28.73px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.la-booking-form {
  width: 348px;
  position: absolute;
  right: 8%;
  /* top: 44%; */
  z-index: 1;
  border-radius: 21px;
  box-shadow: 0px 9.71px 19.43px 0px rgba(0, 0, 0, 0.2784313725);
  margin-bottom: 100px;
}

@media screen and (max-width: 767px) {
  .la-booking-form {
    right: auto;
    top: 50%;
    z-index: 1;
    left: 50%;
    margin-left: -175px;
    margin-top: -215px;
  }
}
.la-wrapper {
  display: flex;
  height: 100vh;
  vertical-align: bottom;
  align-content: flex-end;
  flex-wrap: wrap-reverse;
}`, "",{"version":3,"sources":["webpack://./src/containers/BookingWidget/styles.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAEA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iHAAA;AAAF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;AAJF;;AAMA;EACE,0BAAA;AAHF;;AAKA;EACE,0BAAA;AAFF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;AADF;;AAIA;EACE;IACE,QAAA;EADF;AACF;AAGA;EACE;IACE,QAAA;EADF;AACF;AAGA;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;AADF;;AAIA;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,8DAAA;EACA,oBAAA;AADF;;AAIA;EACE;IACE,WAAA;IACA,QAAA;IACA,UAAA;IACA,SAAA;IACA,mBAAA;IACA,kBAAA;EADF;AACF;AAGA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AADF","sourcesContent":["@font-face {\n  font-family: \"Avenir\";\n  src: url(\"./fonts/Avenir.otf\") format(\"opentype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.landing-page {\n  position: relative;\n  height: 100vh;\n  overflow: hidden;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 43.17%,\n    rgba(255, 255, 255, 0.9) 71.58%,\n    #ffffff 100%\n  );\n}\n.la-logo {\n  position: absolute;\n  margin-top: 25px;\n  display: flex;\n  z-index: 1;\n  width: 100%;\n  justify-content: center;\n}\n\n.la-logo img {\n  width: 150px;\n  object-fit: contain;\n}\n\n.la-background-image img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 1050px;\n  object-fit: cover;\n  z-index: -1;\n}\n.landing-page .react-datepicker-wrapper input[type=\"text\"] {\n  font-size: 14px !important;\n}\n.landing-page .react-datepicker-wrapper input::placeholder {\n  font-size: 15px !important;\n}\n.la-content {\n  position: absolute;\n  left: 8%;\n  color: #1e1e1e;\n  margin-bottom: 80px;\n}\n\n@media only screen and (max-width: 381px) {\n  .la-content {\n    top: 50%;\n  }\n}\n@media screen and (min-width: 382px) and (max-width: 481px) {\n  .la-content {\n    top: 60%;\n  }\n}\n.la-content h1 {\n  font-family: \"Avenir\", sans-serif;\n  margin: 0 0 30px;\n  font-size: 64.64px;\n  font-weight: 500;\n  line-height: 71.82px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n.la-content p {\n  font-family: \"Avenir\", sans-serif;\n  font-size: 28.73px;\n  font-weight: 500;\n  line-height: 28.73px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n.la-booking-form {\n  width: 348px;\n  position: absolute;\n  right: 8%;\n  /* top: 44%; */\n  z-index: 1;\n  border-radius: 21px;\n  box-shadow: 0px 9.71px 19.43px 0px #00000047;\n  margin-bottom: 100px;\n}\n\n@media screen and (max-width: 767px) {\n  .la-booking-form {\n    right: auto;\n    top: 50%;\n    z-index: 1;\n    left: 50%;\n    margin-left: -175px;\n    margin-top: -215px;\n  }\n}\n.la-wrapper {\n  display: flex;\n  height: 100vh;\n  vertical-align: bottom;\n  align-content: flex-end;\n  flex-wrap: wrap-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
